import { render, staticRenderFns } from "./AutomationWizardOverviewBenefits.vue?vue&type=template&id=2ac795f6&scoped=true&"
import script from "./AutomationWizardOverviewBenefits.vue?vue&type=script&lang=js&"
export * from "./AutomationWizardOverviewBenefits.vue?vue&type=script&lang=js&"
import style0 from "./AutomationWizardOverviewBenefits.vue?vue&type=style&index=0&id=2ac795f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac795f6",
  null
  
)

export default component.exports